import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { DealerActions } from 'src/app/common/store/actions/dealer.actions';

import { selectAuthMessage, selectDealerData, selectLoggedInUserDataId, selectDealerMyCarPark} from 'src/app/common/store/state/app.state';
import { Dealer } from 'src/app/public/account/models/dealer.model';
import { Car } from 'src/app/public/car/models/car.model';
import { TransactionRole } from 'src/app/public/common/constants/common-basic-data';
import { ObjectSource } from 'src/app/public/common/constants/general-basic-data';

@Component({
    selector: 'app-dealer-contracts',
    templateUrl: './dealer-contracts.component.html',
    styleUrls: ['./dealer-contracts.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class DealerContractsComponent implements OnInit{

  myDealerData$: Observable<Dealer>;
  myCars$: Observable<Car[]>;
  authFeedback$: Observable<string>;

  currentUserId$: Observable<string>;
  currentUserId: string = "";

  dealer: Dealer = new Dealer();
  myCars : Car[] = [];

  TransactionRole = TransactionRole
  objectSource : ObjectSource = ObjectSource.DEALER

  constructor(
    private store: Store, 

    private route: ActivatedRoute) {

      this.currentUserId$ = this.store.select(selectLoggedInUserDataId);

      this.myDealerData$ = this.store.select(selectDealerData);
      this.myCars$ = this.store.select(selectDealerMyCarPark);

      this.authFeedback$ = store.select(selectAuthMessage);

      
    }
  
  ngOnInit(): void {

    this.currentUserId$.subscribe( (userId: string) => {
      this.currentUserId = userId;
      this.store.dispatch(DealerActions.contractFetchAllMySubmit());
      
    }
    );

    this.myDealerData$.subscribe( (dealer: Dealer) => {
      this.dealer = dealer;
      }
    );

    this.myCars$.subscribe( (cars: Car[]) => {
      this.myCars = cars;
      }
    );
  } 
}
